import React, { useRef, useState, useEffect } from "react";
import "./home.css";
import { motion } from "framer-motion";
import { transition } from "../../utils/transition";
import { fadeIn } from "../../utils/variants";

const BRAND = { navy: "#062b6c", green: "#00ad0f" };

// this is the team member page
const Team = () => {
  const mentors = [
    {
      title:
        "Project Manager | Operations and Business Development Leader | CEO, Scaftech Engineering Services",
      name: "Mabel Irom",
      experience: "",
      image: "/new_img/image-2.jpg",
      knowledge_mentor: "",
      writeup: `
      A seasoned operations and business development executive with over a decade of impactful experience in engineering, equipment inspection, and project management within the oil, gas, and construction industries. Mabel Irom holds a strong academic and professional background in project delivery and technical operations, and currently serves as the Chief Executive Officer of Scaftech Engineering Services, a fast growing multidisciplinary engineering company in Nigeria.
Mabel has consistently demonstrated excellence in building and executing client-centered solutions, overseeing complex projects, and managing high-performance teams across diverse technical domains. Her strategic leadership has positioned Scaftech as a preferred provider for third-party inspections, scaffolding services, equipment maintenance, and industry-focused training programs.
`,
      writeup2: `
Extensive hands-on and executive-level experience in overseeing statutory equipment inspections, rigging operations, mechanical systems maintenance, and technical personnel deployment. Her deep understanding of regulatory frameworks and industry standards has enabled the successful delivery of high-stakes projects for clients in manufacturing, construction, and oil & gas sectors.
Proven track record of driving operational growth, fostering strategic partnerships, and aligning business operations with safety, quality, and performance goals. Her ability to balance business development with technical integrity has earned her recognition as a thought leader in engineering service innovation.
`,
      socials: {
        linkedIn: "",
        youtube: "",
        twitter: "",
        instagram: "",
      },
    },
    {
      title: "HSE Specialist | Mechanical Engineer | Oil & Gas Industry Expert",
      name: "Osere Sikiru",
      experience: "",
      image: "/new_img/image-3.jpg",
      knowledge_mentor: "",
      writeup: `
      A seasoned Health, Safety, and Environment (HSE) professional with over 20 years of extensive experience in the oil and gas industry. Osere Sikiru holds a Bachelor of Engineering in Mechanical Engineering, Coren certified and has consistently demonstrated expertise in developing, implementing, and managing HSE systems and protocols to ensure compliance with international safety standards. His solid engineering background, combined with multiple professional HSE certifications, enables him to bridge technical and safety requirements seamlessly, fostering a culture of safety excellence across projects.
`,
      writeup2: `
Extensive hands-on and leadership experience across upstream and downstream oil and gas operations, including offshore and onshore facilities. Proven track record of reducing incident rates, improving safety performance, and enhancing organizational HSE culture.
To contribute strategic HSE leadership within dynamic organizations, promoting operational excellence, regulatory compliance, and the safeguarding of people, assets, and the environment.
`,
      socials: {
        facebooK: "",
        youtube: "",
        twitter: "",
        instagram: "",
      },
    },
    {
      title:
        "Human Resources Professional | Talent Acquisition Specialist | Organizational Development Enthusiast",
      name: "Victoria Bassey Iton",
      experience: "",
      image: "/new_img/images-4.jpg",
      knowledge_mentor: "",
      writeup: `Victoria is a versatile Human Resources professional with a strong foundation in strategic people management and cross-sectoral experience. She holds a Bachelor of Business Administration (BBA) in Human Resource Management and an Executive MBA (e-MBA) in International Oil and Gas Trade, positioning her uniquely at the intersection of talent development and industry expertise. With a career marked by hands-on involvement in recruitment, performance management, organizational development, and policy implementation, Victoria brings a results-driven and people-centric approach to human capital management.
`,
      writeup2: `
 Her work reflects a deep understanding of aligning HR frameworks with business goals—creating environments where both talent and organizations thrive.
She is particularly skilled at navigating the complexities of workforce planning, employee engagement, and regulatory compliance, especially within high-stakes and evolving industries like energy and oil & gas. Her e-MBA further empowers her to bring global industry insights into HR strategies that drive innovation and growth
`,
      socials: {
        facebooK: "",
        youtube: "",
        twitter: "",
        instagram: "",
      },
    },
    {
      title:
        "Senior Operations Manager / Project Manager / QHSE / Construction Manager",
      name: "George A. Osum",
      experience: "",
      image: "/new_img/image-7.jpg",
      knowledge_mentor: "",
      writeup: `A motivated, seasoned research-based Engineer, Senior Project Manager with PMP & PRINCE2 Certification. He acquired a Master of Science Degree in Engineering Project Management from University of Manchester, United Kingdom, Bachelor's degree in Mechanical engineering and Diploma in Petroleum Economics and HND in Petroleum and Natural Gas Engineering respectively. He has over Twenty-five years of post-graduate industry experience while working on various Subsea Services/Flexible pipelines and EPC projects for Oil & Gas and Construction Industries in Nigeria.  Competency Profile: 
`,
      writeup2: `
Drilling and Completion, Intervention/Workover operations, SURF Engineering/Installation Management, Subsea Engineering/Installation/Equipment Rental/Topside Engineering/Obsolescence management, Process/Petrochemical Engineering, Operations/Maintenance management, Contract Management, Project management expert, Project Controls & EVM- Cost Engineering, Procurement, Commercial management, QHSE /Construction management
`,
      socials: {
        facebooK: "",
        youtube: "",
        twitter: "",
        instagram: "",
      },
    },
    {
      title: "Portfolio Summary",
      name: "DAVID UDOM E.",
      experience: "",
      image: "/new_img/image-6.jpg",
      knowledge_mentor: "",
      writeup: `A motivated, seasoned research-based Engineer, Senior Project Manager with PMP & PRINCE2 Certification. He acquired a Master of Science Degree in Engineering Project Management from University of Manchester, United Kingdom, Bachelor's degree in Mechanical engineering and Diploma in Petroleum Economics and HND in Petroleum and Natural Gas Engineering respectively. He has over Twenty-five years of post-graduate industry experience while working on various Subsea Services/Flexible pipelines and EPC projects for Oil & Gas and Construction Industries in Nigeria.  Competency Profile: 
`,
      writeup2: `
Drilling and Completion, Intervention/Workover operations, SURF Engineering/Installation Management, Subsea Engineering/Installation/Equipment Rental/Topside Engineering/Obsolescence management, Process/Petrochemical Engineering, Operations/Maintenance management, Contract Management, Project management expert, Project Controls & EVM- Cost Engineering, Procurement, Commercial management, QHSE /Construction management
`,
      socials: {
        facebooK: "",
        youtube: "",
        twitter: "",
        instagram: "",
      },
    },
    {
      title: "CHAIRMAN",
      name: "ACHENU C. CHARLES",
      experience: "",
      image: "/new_img/image-5.jpg",
      knowledge_mentor: "",
      writeup: `A motivated, seasoned research-based Engineer, Senior Project Manager with PMP & PRINCE2 Certification. He acquired a Master of Science Degree in Engineering Project Management from University of Manchester, United Kingdom, Bachelor's degree in Mechanical engineering and Diploma in Petroleum Economics and HND in Petroleum and Natural Gas Engineering respectively. He has over Twenty-five years of post-graduate industry experience while working on various Subsea Services/Flexible pipelines and EPC projects for Oil & Gas and Construction Industries in Nigeria.  Competency Profile: 
`,
      writeup2: `
Drilling and Completion, Intervention/Workover operations, SURF Engineering/installation Management, Subsea Engineering/Installation/Equipment Rental/Topside Engineering/ Obsolescence management, Process/Petrochemical Engineering, Operations/Maintenance management, Contract Management, Project management expert, Project Controls & EVM- Cost Engineering, Procurement, Commercial management, QHSE /Construction management
`,
      socials: {
        facebooK: "",
        youtube: "",
        twitter: "",
        instagram: "",
      },
    },
    {
      title: "Executive Personal Assistant and Project Lead",
      name: "PEACE SUNDAY E.",
      experience: "",
      image: "/new_img/Image-1.jpg",
      knowledge_mentor: "",
      writeup: `A motivated, seasoned research-based Engineer, Senior Project Manager with PMP & PRINCE2 Certification. He acquired a Master of Science Degree in Engineering Project Management from University of Manchester, United Kingdom, Bachelor's degree in Mechanical engineering and Diploma in Petroleum Economics and HND in Petroleum and Natural Gas Engineering respectively. He has over Twenty-five years of post-graduate industry experience while working on various Subsea Services/Flexible pipelines and EPC projects for Oil & Gas and Construction Industries in Nigeria.  Competency Profile: 
`,
      writeup2: `
Drilling and Completion, Intervention/Workover operations, SURF Engineering/installation Management, Subsea Engineering/Installation/Equipment Rental/Topside Engineering/ Obsolescence management, Process/Petrochemical Engineering, Operations/Maintenance management, Contract Management, Project management expert, Project Controls & EVM- Cost Engineering, Procurement, Commercial management, QHSE /Construction management
`,
      socials: {
        facebooK: "",
        youtube: "",
        twitter: "",
        instagram: "",
      },
    },
  ];

  const mentorRef = useRef(null);
  const [selectedMentor, setSelectedMentor] = useState(mentors[0]);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleSelectMentor = (mentor) => {
    setSelectedMentor(mentor);
    if (mentorRef.current) {
      mentorRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  // Collapse text whenever you switch to a different mentor
  useEffect(() => {
    setIsExpanded(false);
  }, [selectedMentor]);

  return (
    <motion.section
      variants={fadeIn("Up")}
      transition={transition()}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false }}
      className="relative py-10 md:py-16"
    >
      {/* subtle grid background in case parent doesn't have it */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.06] [background-image:linear-gradient(to_right,#0b1220_1px,transparent_1px),linear-gradient(to_bottom,#0b1220_1px,transparent_1px)] [background-size:40px_40px]" />

      <div className="relative mx-auto max-w-6xl px-5">
        {/* Section header */}
        <div className="mb-8 flex flex-col gap-3 text-center md:mb-10">
          <p className="text-[11px] uppercase tracking-[0.32em] text-slate-400">
            Leadership &amp; Governance
          </p>
          <h2 className="text-2xl font-semibold uppercase text-slate-50 md:text-3xl">
            Meet the <span className="text-emerald-300">Scaftech Team</span>
          </h2>
          <p className="mx-auto max-w-2xl text-sm text-slate-300 md:text-[0.95rem]">
            A multidisciplinary leadership team combining field experience,
            technical depth, and strategic vision across engineering, HSE, HR,
            and operations.
          </p>
        </div>

        {/* Selected mentor card */}
        {selectedMentor && (
          <div
            ref={mentorRef}
            className="mb-10 rounded-3xl border border-slate-700/60 bg-slate-900/70 p-6 shadow-[0_18px_60px_rgba(0,0,0,0.7)] backdrop-blur-xl md:p-8"
          >
            <div className="space-y-6">
              {/* Image at the top */}
              <div className="flex justify-center md:justify-start">
                <div className="relative h-56 w-56 overflow-hidden rounded-3xl border border-slate-600/70 bg-slate-800/70 shadow-[0_18px_60px_rgba(0,0,0,0.9)] md:h-64 md:w-64">
                  <img
                    src={selectedMentor.image}
                    alt={selectedMentor.name}
                    className="h-full w-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
                  <div className="absolute bottom-3 left-4 right-4 flex items-center justify-between text-[10px] text-slate-100">
                    <span className="truncate text-[11px] font-medium uppercase tracking-[0.18em]">
                      {selectedMentor.name}
                    </span>
                    <span className="text-[9px] text-slate-300">
                      Scaftech • Leadership
                    </span>
                  </div>
                </div>
              </div>

              {/* Text content */}
              <div className="space-y-4">
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <div>
                    <p className="text-[11px] uppercase tracking-[0.28em] text-emerald-300">
                      Executive Profile
                    </p>
                    <h3 className="mt-1 text-lg font-semibold uppercase text-slate-50 md:text-xl">
                      {selectedMentor.name}
                    </h3>
                  </div>
                  <span className="inline-flex items-center gap-2 rounded-full border border-emerald-500/40 bg-emerald-500/10 px-3 py-1 text-[10px] uppercase tracking-[0.22em] text-emerald-100">
                    <span
                      className="h-1.5 w-1.5 rounded-full shadow-[0_0_10px_rgba(52,211,153,0.8)]"
                      style={{ background: BRAND.green }}
                    />
                    Core Leadership
                  </span>
                </div>

                <p className="text-[13px] font-medium uppercase tracking-[0.18em] text-slate-300 md:text-[0.8rem]">
                  {selectedMentor.title}
                </p>

                {selectedMentor.experience && (
                  <p className="text-xs uppercase tracking-[0.22em] text-slate-500">
                    Experience: {selectedMentor.experience}
                  </p>
                )}

                <div className="h-px w-full bg-gradient-to-r from-transparent via-slate-700 to-transparent" />

                {/* Brief summary + read more */}
                <div className="space-y-3 text-sm leading-relaxed text-slate-200 md:text-[0.95rem]">
                  {/* brief / first paragraph, clamped when not expanded */}
                  <p
                    className={
                      isExpanded
                        ? ""
                        : "line-clamp-3 whitespace-pre-line"
                    }
                  >
                    {selectedMentor.writeup}
                  </p>

                  {/* extra content only when expanded */}
                  {isExpanded && selectedMentor.writeup2 && (
                    <p className="whitespace-pre-line">
                      {selectedMentor.writeup2}
                    </p>
                  )}

                  <button
                    type="button"
                    onClick={() => setIsExpanded((prev) => !prev)}
                    className="mt-1 text-[11px] font-medium uppercase tracking-[0.22em] text-emerald-300 hover:text-emerald-200"
                  >
                    {isExpanded ? "Show less" : "Read more"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Mentor avatar rail */}
        <div className="relative">
          <p className="mb-3 text-[11px] uppercase tracking-[0.28em] text-slate-400">
            Executive Board &amp; Management Team
          </p>

          <div className="flex gap-4 overflow-x-auto pb-3 pt-1">
            {mentors.map((mentor) => {
              const isActive = selectedMentor?.name === mentor.name;
              return (
                <button
                  key={mentor.name}
                  type="button"
                  onClick={() => handleSelectMentor(mentor)}
                  className={`group flex min-w-[220px] items-center gap-3 rounded-2xl border px-3 py-3 text-left transition-all md:min-w-[250px] ${
                    isActive
                      ? "border-emerald-400/70 bg-emerald-500/10 shadow-[0_12px_40px_rgba(0,0,0,0.7)]"
                      : "border-slate-700/60 bg-slate-900/60 hover:border-emerald-400/60 hover:bg-slate-900/80"
                  }`}
                >
                  <div className="relative h-14 w-14 overflow-hidden rounded-2xl border border-slate-600/70 bg-slate-800/70">
                    <img
                      src={mentor.image}
                      alt={mentor.name}
                      className="h-full w-full object-cover"
                    />
                    {isActive && (
                      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
                    )}
                  </div>

                  <div className="flex-1">
                    <p className="text-[12px] font-semibold text-slate-50">
                      {mentor.name}
                    </p>
                    {mentor.title && (
                      <p className="mt-1 line-clamp-2 text-[11px] text-slate-400">
                        {mentor.title}
                      </p>
                    )}
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Team;
